import { FC, useEffect } from 'react';
import { TitleProps } from './types';

const PrimaryHeadline: FC<TitleProps> = (props) => {
	useEffect(() => {
		console.debug('Screen width:', window.innerWidth);
	}, []);
	return <h1 className="pop-font-normal pop-text-center pop-text-popsizePrimary90 pop-mb-10 pop-text-lg">
  {props.children}
</h1>;
};

export default PrimaryHeadline;
